import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=08758d80&scoped=true"
import script from "./customerList.vue?vue&type=script&lang=js"
export * from "./customerList.vue?vue&type=script&lang=js"
import style0 from "./customerList.vue?vue&type=style&index=0&id=08758d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08758d80",
  null
  
)

export default component.exports